const home =
{
    title       : 'Bienvenue sur votre Plateforme Ambulo.' ,
    description : 'Administrez vos données dans cet espace sécurisé.'
};

export default home  ;
